export default "__VITE_PUBLIC_ASSET__1c0b64b5__"